import { DecimalTextProps } from 'components/text/decimal/DecimalText';
import { WeightText } from 'components/text/decimal/WeightText';
import { ProgressText, type ProgressTextProps } from 'components/text/progress/ProgressText';

type WeightProgressTextProps = {
    value: number;
    target?: number | null;
    size?: DecimalTextProps['size'];
} & Omit<ProgressTextProps, 'value'>;

export function WeightProgressText({ value, target, size, ...rest }: WeightProgressTextProps) {
    return (
        <ProgressText
            value={<WeightText value={value} size={size} />}
            target={target ? <WeightText value={target} size="xs" color="text.disabled" /> : undefined}
            {...rest}
        />
    );
}
